import { memo } from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import get from "lodash/get";
import "./HotelPhotoSection.scss";

const PhotoCarousel = loadable(() => import("app/pages/.shared/PhotoCarousel.jsx"));
const SlideShow = loadable(() => import("app/pages/.shared/Slideshow/SlideShow.jsx"));

const HotelPhotoSection = ({
	isMobile,
	printMode,
	photos = [],
	slideshow = {},
	closeSlideshow,
	resolution,
}) => {
	return (
		<div className="hotel-photo-section">
			{isMobile && !printMode && get(photos, "length") > 0 && (
				<PhotoCarousel photos={photos} resolution={resolution} />
			)}
			{!isMobile && !printMode && slideshow.isSlideshowOpened && (
				<SlideShow
					isOpened={slideshow.isSlideshowOpened}
					close={closeSlideshow}
					photos={photos}
				/>
			)}
		</div>
	);
};

HotelPhotoSection.propTypes = {
	isMobile: PropTypes.bool,
	printMode: PropTypes.bool,
	photos: PropTypes.array,
	slideshow: PropTypes.object,
	closeSlideshow: PropTypes.func,
	resolution: PropTypes.string,
};

export default memo(HotelPhotoSection);
